import {GET_USER_DATA, UPDATE_USER} from '../common/endpoints';
import {IUser} from '../models/IUser';
import {baseAPI} from './BaseAPI';

export const userAPI = baseAPI.injectEndpoints({
    endpoints: (build) => ({
        getUserData: build.query<IUser, void>({
            query: () => ({
                url: GET_USER_DATA,
                keepUnusedDataFor: 3600,
                method: 'GET',
            }),

            providesTags: (result) => [{type: 'User', id: 'UserData'}],
        }),
        updateUser: build.mutation<IUser, IUser>({
            query: (user) => ({
                url: UPDATE_USER,
                method: 'POST',
                body: user,
            }),
            async onQueryStarted(_settings, {dispatch, queryFulfilled}) {
                try {
                    const {data: updatedUser} = await queryFulfilled;
                    dispatch(userAPI.util.updateQueryData('getUserData', undefined, () => updatedUser));
                } catch {
                    // The mutation error is exposed to the settings form by RTK Query.
                }
            },
        }),
    }),
});
